import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledGrid = styled(Grid)({
  alignItems: "center",
  justifyContent: "center",
  height: 36,
});
